import { ApiClient } from "../ApiClient";

/**
 * Helper to generate custom headers for filing options (like metrics)
 */
const getFilingHeaders = (options = {}, extraHeaders = {}) => {
  const headers = { ...extraHeaders };
  if (options.includeMetrics) {
    headers["X-Include-Metrics"] = "true";
  }
  return headers;
};

export const fetchCurrentFiling = (
  url,
  filingId,
  client = null,
  options = {},
) => {
  const headers = getFilingHeaders(options, {
    "X-Filing-Serializer": client,
  });

  return ApiClient.get(`${url}/${filingId}`, headers);
};

export const getFilingList = async (url) => {
  return ApiClient.get(url);
};

export const getFilingServices = async (url) => {
  return ApiClient.get(url);
};

export const createNewFiling = async (url, data) => {
  return ApiClient.post(url, data);
};

export const updateFiling = async (url, data, filingId) => {
  return ApiClient.put(`${url}/${filingId}`, data);
};

export const partialUpdateFiling = async (
  url,
  data,
  filingId,
  options = {},
) => {
  const headers = getFilingHeaders(options);
  return ApiClient.patch(`${url}/${filingId}`, data, headers);
};

export const deleteFiling = async (url, filingId) => {
  return ApiClient.delete(`${url}/${filingId}`);
};

export const fetchFilingLogs = async (filingId) => {
  return ApiClient.get(`tax/filing-logs/${filingId}`);
};

// Dependent API functions
export const getDependents = async (filingId) => {
  return ApiClient.get(`tax/filing/${filingId}/dependents`);
};

export const createDependent = async (filingId, data, options = {}) => {
  const headers = getFilingHeaders(options);
  return ApiClient.post(`tax/filing/${filingId}/dependents`, data, headers);
};

export const updateDependent = async (
  filingId,
  dependentId,
  data,
  options = {},
) => {
  const headers = getFilingHeaders(options);
  return ApiClient.put(
    `tax/filing/${filingId}/dependents/${dependentId}`,
    data,
    headers,
  );
};

export const deleteDependent = async (filingId, dependentId, options = {}) => {
  const headers = getFilingHeaders(options);
  return ApiClient.delete(
    `tax/filing/${filingId}/dependents/${dependentId}`,
    headers,
  );
};

export const downloadFilingPackage = async (filingId) => {
  return ApiClient.get(`tax/filing/${filingId}/download-package`);
};

// Get previous CPAs for matching recommendation
// Get previous expert for a filing
// Response: { expert: { id, first_name, last_name, profile_picture, license_type } } or { expert: null }
// license_type: "CERTIFIED PUBLIC ACCOUNTANT" | "ENROLLED AGENT" | "TAX ATTORNEY"
export const getPreviousExperts = async (filingId) => {
  return ApiClient.get(`tax/filing/${filingId}/filing-matching`);
};

// Trigger matching algorithm with flexible matching type
// Request body structure:
// {
//   matching_type: "previous_expert" | "matching_algorithm",
//   expert_data?: { expert_id: <id>, ... } // Optional, depends on matching_type
// }
//
// Examples:
//   - Previous expert: { matching_type: "previous_expert", expert_data: { expert_id: "123" } }
//   - Matching algorithm: { matching_type: "matching_algorithm" }
//
// Response: Only success status needed (200/201) - matching happens in background
export const triggerFilingMatching = async (filingId, data = {}) => {
  return ApiClient.post(`tax/filing/${filingId}/filing-matching`, data);
};
